module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.38ce1b25.jpeg";